import { useState, useEffect } from "react";
import CommentValidationView from "@/components/CommentValidationView";
import axios from "axios";
import { CommentsAnnotation } from "@/types/types";
import { useAuth } from "@/components/auth/AuthContext";
import { fetchAuthSession } from "aws-amplify/auth";
import { useBrandStore } from "@/stores/brandStore";

const CommentValidationPage = () => {
    const [annotations, setAnnotations] = useState<CommentsAnnotation[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { isAuthenticated } = useAuth();
    const { selectedBrand } = useBrandStore();
    const [projectId, setProjectId] = useState<string | null>(null);

    useEffect(() => {
        // Get project ID from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("id");
        console.log(`id: ${id}`);
        setProjectId(id);
    }, []);

    useEffect(() => {
        const fetchAnnotations = async () => {
            try {
                const useMockAuthentication =
                    import.meta.env.VITE_USE_MOCK_AUTH === "true";
                let idToken;
                if (useMockAuthentication) {
                    idToken = "123";
                } else {
                    const { idToken: token } =
                        (await fetchAuthSession()).tokens ?? {};
                    idToken = token;
                }

                console.log(`isAuthenticated: ${isAuthenticated}`);
                if (!idToken) {
                    throw new Error("No authentication token found");
                }

                if (!projectId) {
                    throw new Error("No project ID found");
                }

                const response = await axios.get<CommentsAnnotation[]>(
                    `${import.meta.env.VITE_API_GATEWAY_URL}/get-annotations`,
                    {
                        headers: {
                            Authorization: `Bearer ${idToken.toString()}`,
                        },
                        params: {
                            brandId: selectedBrand,
                            projectId: projectId,
                        },
                    }
                );

                setAnnotations(response.data);
                setIsLoading(false);
            } catch (err) {
                setError("Failed to fetch annotations");
                setIsLoading(false);
                console.error("Error fetching annotations:", err);
            }
        };

        if (isAuthenticated && projectId) {
            fetchAnnotations();
        }
    }, [isAuthenticated, projectId]);

    if (isLoading) return <div>Loading annotations...</div>;
    if (error) return <div>Error: {error}</div>;
    return (
        <CommentValidationView
            pdfOriginal="https://pub-ca2110a0e0904b7e94c8c7f45dc2ccc3.r2.dev/comment_validation/ozempic/pre.pdf"
            pdfUpdated="https://pub-ca2110a0e0904b7e94c8c7f45dc2ccc3.r2.dev/comment_validation/ozempic/post.pdf"
            annotations={annotations}
        />
    );
};

export default CommentValidationPage;
